import BaseController from 'app/src/controllers/base/BaseController';
import BaseLayoutView from 'app/src/views/base/BaseLayoutView';
import $ from 'jquery';

let singletonInstance = null;

const MODAL_REGION = 'appModal';
const MAIN_VIEW_REGION = 'mainView';

export default class AppViewManager extends BaseController {
  /**
   * Static accessor for the singleton AppViewManager
   *
   * @returns {*}
   */
  static getInstance() {
    return singletonInstance || new AppViewManager();
  }

  /**
   * AppViewManager singleton constructor
   *
   * @returns {AppViewManager}    The singleton instance of the AppViewManager
   */
  constructor() {
    super();
    this.view = new BaseLayoutView({
      el: 'body',
      regions: {
        mainView: '#view',
      },
    });

    singletonInstance = singletonInstance || this;

    return singletonInstance;
  }

  /**
   * This is to standardize how the views are attached to the region.
   * This removes some of the repetitive defining in the constructor.
   * As well as allowing the use of BaseController Methods.
   *
   * @param viewController
   */
  setMainView(viewController) {
    window.merchantos.page.hide();
    this.attachChildViewController(viewController, MAIN_VIEW_REGION);
  }

  /**
   * Provides a standard way to display a modal view that cleans up after itself
   * once the modalViewController's dismiss() method is invoked.
   *
   * @param modalViewController {ModalViewController} The concrete implementation of the modal to be
   *                                                  displayed.
   *
   */
  showModal(modalViewController) {
    this.createRegion(MODAL_REGION);
    this.attachChildViewController(modalViewController, MODAL_REGION);
  }

  /**
   * Dismisses the active modal view controller (if any)
   */
  dismissModal() {
    let modalViewController = this.getAttachedChildViewController(MODAL_REGION);

    if (modalViewController) {
      modalViewController.dismiss();
    }
  }

  /**
   * This is to delay the show until the elements in the #view are ready to be shown.
   * Triggered from BaseController.show()
   */
  onViewShown() {
    const $register = $('#register:visible');
    if (!$register.length) {
      // if the register is visible we don't want to show the view because
      // they exist as siblings within the DOM.
      $('#view').show();
    }
  }

  /**
   * An event handler that is triggered once the current modal view is dismissed.
   */
  onChildViewModalCloseRequested() {
    this.removeRegion(MODAL_REGION);
  }
}
